import React from 'react';
import Spinner from 'react-activity/dist/Spinner';
import 'react-activity/dist/Spinner.css';

interface ButtonPropsBase {
  className?: string;
  colorClassname?: string;
  spacingClassName?: string;
  type?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  spinnerSize?: number;
  disabled?: boolean;
  [key: string]: unknown;
}

type ButtonPropsChildren = ButtonPropsBase & { children: React.ReactNode };
type ButtonPropsLabel = ButtonPropsBase & { label: string };

export type ButtonProps = ButtonPropsChildren | ButtonPropsLabel;

export const Button: React.FC<ButtonProps> = ({
  children,
  className = '',
  colorClassname = 'bg-red text-white',
  spacingClassName = 'px-6 py-2',
  type = 'button',
  loading,
  spinnerSize = 12,
  label,
  ...props
}) => (
  <button
    // eslint-disable-next-line react/button-has-type
    type={type}
    disabled={loading}
    className={`${className} ${colorClassname} ${spacingClassName} text-lg rounded-lg ${
      loading || (props.disabled && 'opacity-[55%]')
    } hover:brightness-[85%] transition-all duration-150`}
    {...props}>
    <div className="flex flex-row justify-center">
      {(label || children) as React.ReactNode}{' '}
      {loading && (
        <div className="pl-2 flex flex-col justify-center">
          <Spinner size={spinnerSize} />
        </div>
      )}
    </div>
  </button>
);
